import { asyncAction } from 'lib/actions';

export const fetchArtworkAction = asyncAction('artworkPage/GET_ARTWORK');
export const fetchAuthorAction = asyncAction('artworkPage/GET_AUTHOR');
